import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import Item from './item';

class ToolbarItems extends PureComponent {
  state = { width: 0 };

  componentDidMount() {
    this.setState({ width: window.innerWidth });
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const {
      list,
      pathName,
      isTop,
      inviteId,
      formatType,
      appType,
      LinkComponent,
      ImageComponent,
    } = this.props;
    const { width } = this.state;

    let rightList = list;
    if (!appType) return null;

    if (width < 1024) {
      rightList = list.filter(
        (item) =>
          item.text !== 'Review Services' && item.text !== 'Become a Reviewer',
      );
    }

    return (
      <>
        {rightList.map((listItem) => (
          <Item
            listItem={listItem}
            key={listItem.text || listItem.icon}
            pathName={pathName}
            isTop={isTop}
            inviteId={inviteId}
            formatType={formatType}
            appType={appType}
            LinkComponent={LinkComponent}
            ImageComponent={ImageComponent}
          />
        ))}
      </>
    );
  }
}

ToolbarItems.propTypes = {
  list: propTypes.arrayOf(propTypes.object),
  pathName: propTypes.string,
  isTop: propTypes.bool,
};

ToolbarItems.defaultProps = {
  list: [{}],
  pathName: '',
  isTop: false,
};

export default ToolbarItems;
